import React from 'react';
import { ApplicationLayoutProps, CustomPageLoader, ProtectedContainerProps, getPages as getPagesCore } from 'omni-package-react-core';
import Constants from '../../Constants';

const DocumentsPage = () => <CustomPageLoader loader={() => import('../DocumentsPage')} />;

const getPages = (
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  ApplicationLayout: React.FC<ApplicationLayoutProps>,
) => getPagesCore([{
  exact: true,
  path: '',
  component: (<ApplicationLayout name="Documents" lob="corpo"><DocumentsPage /></ApplicationLayout>),
  protected: true,
  index: true,
}], ProtectedContainer, isAuthenticated, Constants.BasePageSegment);

export default getPages;
